export enum PaymentMethod {
  ShoppingCard = 1,
  PaymentGateway = 2
}

export enum DeliveryOption {
  Pickup = 0,
  Delivery = 1
}

export interface ArkifiHubCheckoutRequestDto {
  paymentMethod: PaymentMethod;
  totalAmount: number;
  products: CheckoutProductDto[];
  storeLocationId: string;
  address?: string;
  deliveryOption?: DeliveryOption;
  deliveryFee?: number;
  deliveryCompanyName?: string;
  deliveryQuoteId?: string;
  redirectUrl?: string;
  transactionPin?: string;
  cardId?: string; // Optional: Card ID to use for payment when PaymentMethod is PaymentGateway. If provided, charges the saved card directly instead of redirecting to payment gateway.
  platformId: string;
  environmentType: number; // 1 = Test, 2 = Live (matches EnviromentType enum)
}

// Re-export delivery quote types from service for convenience
export type { DeliveryQuoteRequestDto, DeliveryQuoteResponseDto, DeliveryCompanyQuoteDto } from '../services/checkout.service';

export interface CheckoutProductDto {
  productId: string;
  quantity: number;
}

export interface ArkifiHubCheckoutResponseDto {
  orderId: string;
  transactionReference?: string;
  paymentUrl?: string;
  orderStatus: OrderStatus;
  totalAmount: number;
  currency: string;
  createdAt: string;
  message: string;
}

export interface PickupLocationDto {
  storeLocationId: string;
  name: string;
  address: string;
  state: string;
  country: string;
  isActive: boolean;
  businessId: string;
  platformId: string;
}

export enum OrderStatus {
  Success = 0,
  Pending = 1,
  Returned = 2,
  Accepted = 3,
  Confirmed = 4
}

export interface ShoppingCardPaymentResponseDto {
  orderId: string;
  transactionId: string;
  remainingBalance: number;
  amountDeducted: number;
  orderStatus: OrderStatus;
  message: string;
}

export interface VerifyArkifiHubCheckoutRequestDto {
  transactionReference: string;
}

export interface VerifyArkifiHubCheckoutResponseDto {
  isSuccessful: boolean;
  message: string;
  transactionReference: string;
  orderStatus: OrderStatus;
  amount: number;
  orderId: string;
}

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

export interface OrderProductDto {
  productId: string;
  quantity: number;
  productName?: string;
  price: number;
  productImage?: string;
}

export interface ArkifiHubOrderDto {
  id: string;
  platformId: string;
  businessId: string;
  arkifiHubCustomerId: string;
  products: OrderProductDto[];
  address: string;
  pickUpLocation?: string;
  pickupLocationName?: string;
  isAvailableForDelivery: boolean;
  orderStatus: OrderStatus;
  enviromentType: number;
  transactionReference?: string;
  gateway?: string;
  totalAmount: number;
  dateCreated: string;
  dateUpdated: string;
  orderStatusDisplay: string;
  environmentTypeDisplay: string;
  totalProducts: number;
  uniqueProducts: number;
  // Delivery information
  deliveryFee: number;
  deliveryCompanyName?: string;
  deliveryTrackingId?: string;
  subtotal: number;
}

export interface ArkifiHubOrderHistoryDto {
  orders: ArkifiHubOrderDto[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

/** Saved delivery address (Terminal Africa) for the current user. */
export interface SavedDeliveryAddressDto {
  id: string;
  platformId: string;
  businessId: string;
  environmentType: number;
  providerName: string;
  providerAddressId: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  line1: string;
  line2?: string;
  city: string;
  state: string;
  country: string;
  zip?: string;
  isResidential?: boolean;
  dateCreated: string;
  dateUpdated: string;
}

/** Request body to update a saved delivery address (syncs to Terminal Africa + Arkifi DB). */
export interface UpdateSavedDeliveryAddressRequestDto {
  providerAddressId: string;
  line1: string;
  line2?: string;
  city: string;
  state: string;
  country: string;
  zip?: string;
  firstName?: string;
  lastName?: string;
  name?: string;
  email?: string;
  phone?: string;
  isResidential?: boolean;
}
